module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    class: {
      'active': _vm.show$
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f6f1f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/panel.vue
// module id = 383
// module chunks = 0